export var Endpoint;
(function (Endpoint) {
    Endpoint["topicsearch"] = "topicsearch";
    Endpoint["aggregations"] = "aggregations";
    Endpoint["correlations"] = "correlations";
})(Endpoint || (Endpoint = {}));
